import { render, staticRenderFns } from "./CheckoutSuccessView.vue?vue&type=template&id=6f926c7d"
var script = {}
import style0 from "./CheckoutSuccessView.vue?vue&type=style&index=0&id=6f926c7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default})
